export enum STEPPER_LABEL {
  NUMBER_PLAYERS = "Number of players",
  SELECT_DART_GAME = "Select Dart Game",
  BOT_DIFFICULTY = "Select Bot Difficulty",
  X01_SCORE = "Select X01 Score",
  IN_OUT = "Input options",
  ROOM_TYPE = "Select room type",
  HOST_JOIN = "Host/Join",
  ROOM_CODE = "Room code",
  ROUNDS = "Choose rounds"
}
